import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CampaignDetail from './pages/CampaignDetail';
import ApplicantScoring from './pages/ApplicantScoring';
import ProfileManagement from './pages/ProfileManagement';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Trang đăng nhập */}
          <Route path="/login" element={<Login />} />

          {/* Trang dashboard - cần đăng nhập */}
          <Route
            path="/trangchu"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Chi tiết đợt tuyển dụng */}
          <Route
            path="/campaign/:id"
            element={
              <ProtectedRoute>
                <CampaignDetail />
              </ProtectedRoute>
            }
          />

          {/* Chấm điểm ứng viên */}
          <Route
            path="/campaign/:campaignId/applicant/:applicantId"
            element={
              <ProtectedRoute>
                <ApplicantScoring />
              </ProtectedRoute>
            }
          />

          {/* Quản lý hồ sơ */}
          <Route
            path="/ho-so"
            element={
              <ProtectedRoute requiredPermission="1">
                <ProfileManagement />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/trangchu" replace />} />
          <Route path="*" element={<Navigate to="/trangchu" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
